import { httpClient } from "api/httpClient";
import { ScannerLogContextType } from "entities/ScannerLogContextType";

// Fire-and-forget: scan logging must never block or break the scan flow.
// scanned_text is capped to the backend column size so an oversized scan
// doesn't fail validation and silently lose the log entry.
export const logScannerAction = (
	scannedText,
	{ scannerName = null, contextType = ScannerLogContextType.other, contextId = null, terminalId = null } = {}
) => {
	httpClient("scanner-logs", {
		method: "POST",
		body: JSON.stringify({
			scanned_text: String(scannedText ?? "").slice(0, 256),
			scanner_name: scannerName,
			context_type: contextType,
			context_id: contextId,
			terminal_id: terminalId,
		}),
	}).catch((err) => console.warn("Failed to log scanner action:", err));
};
